import { FullscreenSpinner, Toaster } from '@festina-life/ui/feedback'
import { PageLayout } from '@festina-life/ui/structure'
import { Suspense } from 'react'

import { ChangelogDiffModal } from '../../components/changelog/ChangelogDiffModal'
import { TopBar } from '../../components/topBar/TopBar'
import { LayoutPanels } from './LayoutPanels'

export const MainLayout = () => (
  <PageLayout topBar={<TopBar />}>
    <Suspense fallback={<FullscreenSpinner />}>
      <LayoutPanels />
      <ChangelogDiffModal />
      <Toaster />
    </Suspense>
  </PageLayout>
)
